import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getIsCheckoutLoyaltyInternationalTrip from './getIsCheckoutLoyaltyInternationalTrip'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import getIsTasteOfGoldEligibleCheckout from './getIsTasteOfGoldEligibleCheckout'
import getCheckoutLoyaltyEligibleTransferOptions from './getCheckoutLoyaltyEligibleTransferOptions'
import { getHasBothTransferDirectionsBundled } from 'checkout/selectors/experienceSelectors'

const getCanRedeemTransferLoyaltyBenefit = createSelector(
  (state: App.State) => state.loyalty.account.data?.benefits,
  (state: App.State) => getIsCheckoutLoyaltyInternationalTrip(state),
  (state: App.State) => state.loyalty.config?.transferAirports,
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => getIsTasteOfGoldEligibleCheckout(state),
  (state: App.State) => getCheckoutLoyaltyEligibleTransferOptions(state),
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => getHasBothTransferDirectionsBundled(state),
  (
    userBenefits,
    isInternationalTrip,
    airportCodes = EmptyArray,
    isCurrentRegionUserLoyaltyRegion,
    postPurchase,
    isTasteOfGoldEligibleCheckout,
    loyaltyEligibleTransferOptions,
    currentRegionCode,
    hasBothTransferDirectionsBundled,
  ): boolean => {
    if (hasBothTransferDirectionsBundled) return false

    const hasLoyaltyTransferOptions = loyaltyEligibleTransferOptions.canUseOneWay ||
      loyaltyEligibleTransferOptions.canUseReturn ||
      currentRegionCode === 'AU'

    if (!isCurrentRegionUserLoyaltyRegion || !!postPurchase || !hasLoyaltyTransferOptions) return false

    const transferBenefit = userBenefits?.find(benefit => benefit.code === 'airport_transfer')
    const hasTransferBenefit = !!transferBenefit && (transferBenefit.unlimited || !!transferBenefit.remaining)

    return airportCodes.length > 0 &&
      (hasTransferBenefit || isTasteOfGoldEligibleCheckout) &&
      isInternationalTrip
  },
)

export default getCanRedeemTransferLoyaltyBenefit
